import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useExtracted } from "next-intl";
import { UnauthShell } from "@/components/layout/UnauthShell";

export function NotFound() {
  const te = useExtracted();
  const title = te("Page not found");
  useEffect(() => {
    document.title = `${title} | ABG One`;
    const existing = document.head.querySelector<HTMLMetaElement>(
      'meta[name="robots"]',
    );
    const robots = existing ?? document.createElement("meta");
    const previous = robots.content;
    robots.name = "robots";
    robots.content = "noindex, follow";
    if (!existing) document.head.append(robots);
    return () => {
      if (existing) robots.content = previous;
      else robots.remove();
    };
  }, [title]);
  return (
    <UnauthShell>
      <main className="flex flex-col items-center gap-6 px-6 text-center">
        <p className="text-muted-foreground">404</p>
        <h1 className="text-2xl font-semibold">{title}</h1>
        <Link className="underline underline-offset-4" to="/">
          {te("Back to home")}
        </Link>
      </main>
    </UnauthShell>
  );
}
